import { render, staticRenderFns } from "./MyDashboard.vue?vue&type=template&id=edd482da&scoped=true"
import script from "./MyDashboard.vue?vue&type=script&lang=js"
export * from "./MyDashboard.vue?vue&type=script&lang=js"
import style0 from "./MyDashboard.vue?vue&type=style&index=0&id=edd482da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd482da",
  null
  
)

export default component.exports